"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var recoil_1 = require("recoil");
var react_hook_form_1 = require("react-hook-form");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("@/components");
var Styled = __importStar(require("./EmailSendModalDialog.styled"));
var api = __importStar(require("@/api"));
var store_1 = require("@/store");
var ApplicationStatusBadge_component_1 = __importStar(require("@/components/common/ApplicationStatusBadge/ApplicationStatusBadge.component"));
var chevron_right_16_svg_1 = __importDefault(require("@/assets/svg/chevron-right-16.svg"));
var utils_1 = require("@/utils");
var hooks_1 = require("@/hooks");
var Toast_component_1 = require("../Toast/Toast.component");
var constants_1 = require("@/constants");
var types_1 = require("@/types");
var EmailSendModalDialog = function (_a) {
    var selectedApplications = _a.selectedApplications, _b = _a.isSendFailed, isSendFailed = _b === void 0 ? false : _b, _c = _a.showSummary, showSummary = _c === void 0 ? false : _c, _d = _a.failedEmailRequests, failedEmailRequests = _d === void 0 ? [] : _d;
    var _e = __read((0, react_2.useState)(false), 2), isLoading = _e[0], setIsLoading = _e[1];
    var selectedApplicationIds = selectedApplications.map(function (application) { return application.applicationId; });
    var selectedFailedApplicationIds = failedEmailRequests.map(function (_a) {
        var applicationId = _a.applicationId;
        return applicationId;
    });
    var selectedResults = (0, utils_1.uniqArray)(selectedApplications.map(function (application) { return application.result.status; }));
    var selectedConfirmStatuses = (0, utils_1.uniqArray)(selectedApplications.map(function (application) { return application.confirmationStatus; }));
    var handleAddToast = (0, hooks_1.useToast)().handleAddToast;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var setEmailSendDetailListModal = (0, recoil_1.useSetRecoilState)((0, store_1.$modalByStorage)(store_1.ModalKey.emailSendDetailListModalDialog));
    var refreshSelectorFamilyByKey = (0, hooks_1.useRefreshSelectorFamilyByKey)();
    var handleOpenEmailSendDetailListModalDialog = function () {
        setEmailSendDetailListModal({
            key: store_1.ModalKey.emailSendDetailListModalDialog,
            props: {
                selectedApplications: selectedApplications,
            },
            isOpen: true,
        });
    };
    var handleRemoveCurrentModal = (0, recoil_1.useRecoilCallback)(function (_a) {
        var set = _a.set;
        return function () {
            set((0, store_1.$modalByStorage)(store_1.ModalKey.emailSendModalDialog), {
                key: store_1.ModalKey.emailSendModalDialog,
                isOpen: false,
            });
        };
    });
    var _f = (0, react_hook_form_1.useForm)(), handleSubmit = _f.handleSubmit, register = _f.register;
    var handleSendEmail = (0, recoil_1.useRecoilCallback)(function (_a) {
        var set = _a.set;
        return function (_a) {
            var memo = _a.memo, templateName = _a.templateName;
            set((0, store_1.$modalByStorage)(store_1.ModalKey.alertModalDialog), {
                key: store_1.ModalKey.alertModalDialog,
                isOpen: true,
                props: {
                    heading: '발송하시겠습니까?',
                    paragraph: '이메일 발송내역에서 확인하실 수 있습니다.',
                    confirmButtonLabel: '발송',
                    handleClickConfirmButton: function () {
                        (0, utils_1.request)({
                            requestFunc: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            setIsLoading(true);
                                            return [4 /*yield*/, api.postEmailSend({
                                                    applicationIds: isSendFailed
                                                        ? selectedFailedApplicationIds
                                                        : selectedApplicationIds,
                                                    memo: memo,
                                                    templateName: templateName,
                                                })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                            errorHandler: handleAddToast,
                            onSuccess: function () {
                                handleRemoveCurrentModal();
                                handleAddToast({
                                    type: Toast_component_1.ToastType.success,
                                    message: '이메일 발송 완료',
                                });
                                navigate(constants_1.PATH.EMAIL);
                            },
                            onCompleted: function () {
                                setIsLoading(false);
                                set((0, store_1.$modalByStorage)(store_1.ModalKey.alertModalDialog), {
                                    key: store_1.ModalKey.alertModalDialog,
                                    isOpen: false,
                                });
                                refreshSelectorFamilyByKey('emailSendingList');
                            },
                        });
                    },
                },
            });
        };
    });
    var props = {
        heading: isSendFailed ? '실패인원 이메일 재발송' : '이메일 발송',
        footer: {
            cancelButton: {
                label: '취소',
            },
            confirmButton: {
                label: '발송',
                onClick: handleSubmit(handleSendEmail),
                type: 'submit',
                isLoading: isLoading,
            },
        },
        handleCloseModal: handleRemoveCurrentModal,
        closeOnClickOverlay: false,
    };
    return ((0, jsx_runtime_1.jsx)(components_1.ModalWrapper, __assign({}, props, { children: (0, jsx_runtime_1.jsxs)(Styled.EmailSendModalContainer, { children: [showSummary && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Styled.TitleArea, { children: [(0, jsx_runtime_1.jsx)(components_1.TitleWithContent, __assign({ title: "\uCD1D \uBC1C\uC1A1 \uC778\uC6D0" }, { children: selectedApplicationIds.length }), void 0), !isSendFailed && ((0, jsx_runtime_1.jsxs)("button", __assign({ type: "button", onClick: handleOpenEmailSendDetailListModalDialog }, { children: ["\uBC1C\uC1A1 \uC778\uC6D0 \uC0C1\uC138\uBCF4\uAE30", (0, jsx_runtime_1.jsx)(chevron_right_16_svg_1.default, {}, void 0)] }), void 0))] }, void 0), !isSendFailed && ((0, jsx_runtime_1.jsx)(Styled.TitleArea, { children: (0, jsx_runtime_1.jsx)(components_1.TitleWithContent, __assign({ title: "\uBC1C\uC1A1\uC774\uBA54\uC77C" }, { children: "recruit.mashup@gmail.com" }), void 0) }, void 0)), (0, jsx_runtime_1.jsxs)(Styled.StatusArea, __assign({ isSendFailed: isSendFailed }, { children: [(0, jsx_runtime_1.jsx)(components_1.TitleWithContent, __assign({ title: "\uC0AC\uC6A9\uC790 \uD655\uC778 \uC5EC\uBD80" }, { children: selectedConfirmStatuses === null || selectedConfirmStatuses === void 0 ? void 0 : selectedConfirmStatuses.map(function (each) { return ((0, jsx_runtime_1.jsx)(ApplicationStatusBadge_component_1.default, { text: ApplicationStatusBadge_component_1.ApplicationConfirmationStatus[each] }, each)); }) }), void 0), (0, jsx_runtime_1.jsx)(components_1.TitleWithContent, __assign({ title: "\uD569\uACA9 \uC5EC\uBD80" }, { children: selectedResults === null || selectedResults === void 0 ? void 0 : selectedResults.map(function (each) { return ((0, jsx_runtime_1.jsx)(ApplicationStatusBadge_component_1.default, { text: ApplicationStatusBadge_component_1.ApplicationResultStatus[each] }, each)); }) }), void 0)] }), void 0), (0, jsx_runtime_1.jsx)(Styled.Divider, {}, void 0)] }, void 0)), (0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ required: true, "$size": "xs", label: "\uBC1C\uC1A1\uBA54\uBAA8", placeholder: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694" }, register('memo', { required: true })), void 0), (0, jsx_runtime_1.jsxs)(Styled.Label, { children: ["\uBC1C\uC1A1\uC720\uD615", (0, jsx_runtime_1.jsx)(Styled.RequiredDot, {}, void 0)] }, void 0), Object.entries(types_1.EmailTypes).map(function (_a) {
                    var _b = __read(_a, 2), englishEmailType = _b[0], koreanEmailType = _b[1];
                    return englishEmailType !== 'SUBMIT' && ((0, jsx_runtime_1.jsx)(components_1.RadioButtonField, __assign({ label: koreanEmailType, value: englishEmailType }, register('templateName', { required: true })), koreanEmailType));
                })] }, void 0) }), void 0));
};
exports.default = EmailSendModalDialog;
